import {z} from "zod"
import {GraphNode} from "#graph/nodes/graph/node"

export const GetPropertyDefinition = {
    validation: {
        returns: z.any(),
        parameters: z.object({key: z.string(), value: z.instanceof(GraphNode)}),
    },
}
